import { useEffect } from 'react';
import PropTypes from 'prop-types';
import ArticleListItem, { ArticleListItemPropTypes } from './articleListItem';

export default function ArticleList({ articles, title, onRender }) {
  useEffect(() => {
    if (onRender) {
      onRender();
    }
  }, [onRender]);

  return (
    <>
      {title && articles.length > 0 && (<div className="u-margin-m-bottom">{title}</div>)}
      {articles.map(article => (
        <ArticleListItem key={`${article.key}`} {...article} />
      ))}
    </>
  );
}

ArticleList.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.shape(ArticleListItemPropTypes)).isRequired,
  title: PropTypes.string,
  onRender: PropTypes.func,
};

ArticleList.defaultProps = {
  title: undefined,
  onRender: undefined,
};
